import { useParams } from "next/navigation";

export const useAssignUserSingleSelectHelper = () => {
  // ID will be defined on the main screener locations table, but undefined on
  // the "Assigned to me" table
  const { id } = useParams<{ id?: string }>();
  const onAssignedToMeView = !id;

  return {
    onAssignedToMeView,
  };
};
